import { Role } from "../../types/role";

const F9un: Role = {
  primary: [
    "Passen",
    "Tackling",
    "Einsatzfreude",
    "OhneBall",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Abschluss",
    "Ballannahme",
    "Dribbling",
    "Technik",
    "Weitschuesse",
    "Aggressivitaet",
    "Antizipation",
    "Entscheidungen",
    "Nervenstaerke",
    "Stellungsspiel",
    "Antritt",
    "Balance",
    "Kraft",
    "Schnelligkeit",
  ],
  physis: "angriff",
};

export const F9 = {
  F9un,
};
